import FindUserState from '../interfaces/states/FindUserState';

import * as Const from '../constants';

const initState: FindUserState = {
  authIdInputValue: '',
  emailInputValue: '',
  disabledAuth: false,
  disabledEmail: false,
  isLoading: false,
  isError: false,
  userInfo: {},
  activeTab: 0,
  isErrorWhileSearch: false,
};

export default function findUser (state: FindUserState = initState, action): FindUserState {
  switch (action.type) {

    case Const.FETCH_FIND_USER_INIT:
      return {
        ...initState,
        isLoading: false,
      };

    case Const.FETCH_FIND_USER_PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };

    case Const.FETCH_FIND_USER_SUCCESS:
      return {
        ...state,
        userInfo: action.payload,
        isLoading: false,
        isError: false,
      };

    case Const.FETCH_FIND_USER_FAIL:
      return {
        ...state,
        isLoading: false,
        isError: true,
        isErrorWhileSearch: true,
      };

    case Const.FETCH_FIND_USER_FAIL_WHILE_SEARCH_INIT:
      return {
        ...state,
        isErrorWhileSearch: false,
      };

    case Const.FETCH_FIND_USER_DISABLE_EMAIL:
      return{
        ...state,
        emailInputValue: '',
        disabledEmail: false,
        disabledAuth: true,
      };

    case Const.FETCH_FIND_USER_DISABLE_ID:
      return{
        ...state,
        authIdInputValue: '',
        disabledEmail: true,
        disabledAuth: false,
      };

    case Const.FETCH_FIND_USER_AUTH_ID:
      return {
        ...state,
        authIdInputValue: action.payload,
        disabledEmail: true,
        disabledAuth: false,
      };

    case Const.FETCH_FIND_USER_EMAIL:
      return {
        ...state,
        emailInputValue: action.payload,
        disabledEmail: false,
        disabledAuth: true,
      };

    case Const.FETCH_FIND_USER_ENABLE_INPUTS:
      return {
        ...state,
        disabledEmail: false,
        disabledAuth: false,
      };

    case Const.FETCH_FIND_USER_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.payload,
      };

    default:
      return state;
  }
}
